import { environment } from 'environments/environment';

/** SW update E2E (e2e-a / e2e-b) asserts deploy via html[data-e2e-sw-build]; normal builds omit e2eSwBuildMarker. */
export function applyE2eSwBuildMarker(): void {
    if (environment.e2eSwBuildMarker) {
        document.documentElement.dataset['e2eSwBuild'] = environment.e2eSwBuildMarker;
    }
}
